import {
  GENDER_CODE_CIAM,
  GENDER_OPTIONS_LABEL,
  RegistrationFlowFormValues,
} from '../types/registrationFlows';
import { FormikRadioButtonOption } from '../components/WrapperComponents/FormikRadioButtonPicker';

export function mapGenderCodesToFormikRadioButtonOptions(
  values: RegistrationFlowFormValues
): FormikRadioButtonOption[] {
  return Object.values(GENDER_CODE_CIAM).map((key) => {
    const label = GENDER_OPTIONS_LABEL[key];
    return {
      value: key,
      label,
      checked: values.gender === key,
    };
  });
}
